import { render, staticRenderFns } from "./CryptoTab.vue?vue&type=template&id=ddecdcd4&scoped=true"
import script from "./CryptoTab.vue?vue&type=script&lang=js"
export * from "./CryptoTab.vue?vue&type=script&lang=js"
import style0 from "./CryptoTab.vue?vue&type=style&index=0&id=ddecdcd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddecdcd4",
  null
  
)

export default component.exports